import { useEffect, useState } from "react";
import "../../Pages/HomePage.css";
import createIncidentAPI from "../../API/useCreateIncidentAPI"; // Import the API function from the api.js file
import useSenapiVehiclesInfo from "../../API/useSenapiVehiclesInfo";
import useSenapiPumps from "../../API/useSenapiPumps";
import useSenapiFuelTypes from "../../API/SenapiFuelTypes";
import useGetEmployees from "../../API/useGetEmployees";
import { APP_SERVICES_URL, IOU } from "../../Constant/constant";
import SimpleBackdrop from "../SimpleBackdrop";
import { Modal } from "react-bootstrap";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import userSession from "../../Constant/auth";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import DateConfirmModal from "./DateConfirmModal";
// import { faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
const IouModal = ({
  selectedOptions,
  setSelectedEventData,
  show,
  onHide,
  setSuccessIOU,
  settitleData,
  setBodyData,
}) => {
  const intitialIouDetails = {
    customerName: "",
    customerPhoneNumber: "",
    customerAddress: {
      address1: "",
      address2: "",
      city: "",
      state: "",
      postCode: "",
    },
    licencePlateNumber: "",
    colour: "",
    shape: "",
    make: "",
    incidentDate: "",
    fuelType: "",
    fuelCost: "",
    fuelLitres: "",
    reference: "",
    pumpNumber: "",
    note: "",
    employeeName: "",
    type: IOU,
    reason: "",
  };

  const { authHeader } = userSession;
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [formattedDate, setFormattedDate] = useState("");
  const [formattedTime, setFormattedTime] = useState("");

  useEffect(() => {
    const checkGoogleMaps = () => {
      if (window.google && window.google.maps) {
        setGoogleMapsLoaded(true);
      } else {
        setTimeout(checkGoogleMaps, 500); // Retry after 500ms
      }
    };

    checkGoogleMaps();
  }, []);

  useEffect(() => {
    const pad = (num) => String(num).padStart(2, "0");
    const year = selectedDate.getFullYear();
    const month = pad(selectedDate.getMonth() + 1);
    const day = pad(selectedDate.getDate());
    const hours = pad(selectedDate.getHours());
    const minutes = pad(selectedDate.getMinutes());

    setFormattedDate(`${day}/${month}/${year}`);
    setFormattedTime(`${hours}:${minutes}`);
  }, [selectedDate]);


  const formatDateTimeLocal = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      "T" +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes())
    );
  };

  const resetSelectedEventData = () => {
    setSelectedEventData((prevOptions) => {
      const resetOptions = {};
      Object.keys(prevOptions).forEach((key) => {
        resetOptions[key] = "";
      });
      return resetOptions;
    });
  };

  const [selectedOption, setSelectedOption] = useState("ID Provided");
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  const customerId = userData ? userData.custID : null;
  const site = userData ? userData.sites[0].name : null;
  const [iouDetails, setIouDetails] = useState(intitialIouDetails);
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const { pumpData } = useSenapiPumps();
  const { colors, models, shapes } = useSenapiVehiclesInfo(customerId);
  const { fuelTypes } = useSenapiFuelTypes(site);
  const { employees } = useGetEmployees();
  const [showModal, setShowModal] = useState(false);
  const [tempDate, setTempDate] = useState(null); // to hold user-selected date if it's old
  const reasons = [
    "Card Declined",
    "Forgot cash/card",
    "Other Reason",
    "Refused IOU",
  ];
  // Filter employees with active=true
  const activeEmployees = employees.filter(
    (employee) => employee.active === true
  );

  // Update the licencePlateNumber and eventID fields when selectedEventData changes
  useEffect(() => {
    if (
      typeof selectedOptions.eventID === "string" &&
      selectedOptions.eventID.trim() === ""
    ) {
      setIouDetails((prevDetails) => {
        const updatedDetails = Object.assign({}, prevDetails);
        if (selectedOptions.ocr != null) {
          updatedDetails.licencePlateNumber = selectedOptions.ocr;
        }
        // Remove the eventID property
        delete updatedDetails.eventID;
        updatedDetails.pumpNumber = selectedOptions.id;
        return updatedDetails;
      });
    } else {
      setIouDetails((prevDetails) => {
        const updatedDetails = Object.assign({}, prevDetails);
        if (selectedOptions.ocr != null) {
          updatedDetails.licencePlateNumber = selectedOptions.ocr;
        }
        updatedDetails.eventID = selectedOptions.eventID;
        updatedDetails.pumpNumber = selectedOptions.id;
        return updatedDetails;
      });
    }
  }, [selectedOptions]);

  const handleChangeMaps = (address) => {
    // Make sure address is string
    if (typeof address !== "string") address = "";

    setIouDetails((prevDetails) => ({
      ...prevDetails,
      customerAddress: {
        ...prevDetails.customerAddress,
        address1: address,
      },
    }));
  };

  const handleSelect = async (address) => {
    if (typeof address !== "string") address = "";

    setIouDetails((prevDetails) => ({
      ...prevDetails,
      customerAddress: {
        ...prevDetails.customerAddress,
        address1: address,
      },
    }));

    if (!googleMapsLoaded) {
      // No autocomplete, skip geocode
      return;
    }

    try {
      const results = await geocodeByAddress(address, {
        componentRestrictions: { country: "AU" },
      });

      const addressComponents = extractAddressComponents(results[0]);
      const { street, city, state, postcode } = addressComponents;

      setIouDetails((prevDetails) => ({
        ...prevDetails,
        customerAddress: {
          ...prevDetails.customerAddress,
          address1: street,
          city,
          state,
          postCode: postcode,
        },
      }));
    } catch (error) {
      console.error("Error", error);
    }
  };

  const extractAddressComponents = (place) => {
    let street = "";
    let city = "";
    let state = "";
    let postcode = "";

    place.address_components.forEach((component) => {
      if (component.types.includes("street_number")) {
        street += component.long_name + " ";
      }
      if (component.types.includes("route")) {
        street += component.long_name;
      }
      if (component.types.includes("locality")) {
        city = component.long_name;
      }
      if (component.types.includes("administrative_area_level_1")) {
        state = component.short_name;
      }
      if (component.types.includes("postal_code")) {
        postcode = component.long_name;
      }
    });

    return { street: street.trim(), city: city, state: state, postcode: postcode };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const generalValidationPattern = /^[A-Za-z0-9\s]*$/;
    const decimalValidationPattern = /^\d{0,10}(\.\d{0,2})?$/;
    const removeLeadingZeros = (val) => {
      // If value starts with leading zeros followed by a digit, remove leading zeros
      if (!val || typeof val !== 'string') return val;
      return val.replace(/^0+(\d)/, "$1");
    };
    if (name.startsWith("customerAddress.")) {
      const addressField = name.split(".")[1];
      let sanitizedValue = value || "";

      // Remove negative symbols from postCode
      if (addressField === "postCode") {
        sanitizedValue = sanitizedValue.replace(/[^0-9]/g, "");
      } else if (addressField === "city") {
        sanitizedValue = sanitizedValue.replace(/[^A-Za-z\s'-]/g, ""); // Allows letters, spaces, hyphens, and apostrophes for city
      }
      setIouDetails((prevDetails) => {
        return Object.assign({}, prevDetails, {
          customerAddress: Object.assign({}, prevDetails.customerAddress, {
            [addressField]: addressField === "postCode"
              ? (sanitizedValue ? parseInt(sanitizedValue, 10) : "")
              : sanitizedValue,
          }),
        });
      });
    } else {
      // Existing handleChange logic for other fields
      if (name === "fuelCost" || name === "fuelLitres") {
        if (decimalValidationPattern.test(value || "")) {
          const sanitizedValue = removeLeadingZeros(value);
          setIouDetails((prevDetails) => {
            return Object.assign({}, prevDetails, {
              [name]: sanitizedValue,
            });
          });
        }
      } else if (name === "licencePlateNumber" || name === "reference") {
        const trimmedValue = (value || "").replace(/\s/g, "");
        const limitedValue =
          name === "licencePlateNumber"
            ? trimmedValue.slice(0, 10)
            : trimmedValue.slice(0, 15);
        const uppercaseValue = limitedValue.toUpperCase();
        const isValidInput = generalValidationPattern.test(uppercaseValue);
        if (isValidInput || uppercaseValue === "") {
          setIouDetails((prevDetails) => {
            return Object.assign({}, prevDetails, {
              [name]: uppercaseValue,
            });
          });
        }
      } else {
        setIouDetails((prevDetails) => {
          return Object.assign({}, prevDetails, {
            [name]: value || "",
          });
        });
      }
    }

    // Check for label error when any input field changes
    checkLabelErrorOnChange(name, value);
  };


  const handleBlur = (event) => {
    const { name, value } = event.target;

    if (
      (name === "fuelCost" || name === "fuelLitres") &&
      value &&
      !isNaN(parseFloat(value)) &&
      parseFloat(value) <= 0
    ) {
      setIouDetails(Object.assign({}, iouDetails, { [name]: "" }));
      // console.log(name + " must be greater than 0.");
    }
  };
  const checkLabelErrorOnChange = (name, value) => {
    if (value && typeof value === 'string' && value.trim() !== "") {
      setLabelError("");
    }
  };

  const handleDateChange = (event) => {
    const value = event.target.value;
    const parsedDate = new Date(value);

    if (isNaN(parsedDate)) return;

    const now = new Date();
    const min = new Date();
    min.setDate(now.getDate() - 15);

    if (parsedDate < min) {
      setTempDate(parsedDate);  // store temporarily
      setShowModal(true);       // trigger modal
    } else if (parsedDate > now) {
      alert("Please select a date within the last 15 days.");
      const fallback = formatDateTimeLocal(now);
      setSelectedDate(now);
      event.target.value = fallback;
    } else {
      setSelectedDate(parsedDate);
    }
  };



  const currentDateTime = new Date();
  const minDateTime = new Date();
  minDateTime.setDate(currentDateTime.getDate() - 14);

  const uploadFile = async (eventID, file, fileType) => {
    try {
      const customerId = userData ? userData.custID : null;
      const url = APP_SERVICES_URL + "/sn-events-service/" + customerId + "/file?eventID=" + eventID + "&type=" + fileType + "&siteName=" + site;

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: authHeader,
        },
        body: formData,
      });

      if (response.status !== 200) {
        throw new Error(`server responded with status ${response.status}`);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error; // Re-throw the error to handle it in your handleSubmit catch block
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setLoading(true);
    let isOptionSelected = false; // Flag to track if any option is selected
    let isEventCreated = false; // Flag to track if event creation was successful
    let isEventFileUploaded = false;
    let eventID = null; // Track the event ID
    setSuccessIOU(false);

    try {
      const utcTime = moment.utc(selectedDate);
      const localTime = utcTime.local();
      const localTimeWithOffset = localTime.format("YYYY-MM-DDTHH:mm:ss.SSS");

      // Trim the customerPhoneNumber directly with safe handling
      if (iouDetails.customerPhoneNumber && typeof iouDetails.customerPhoneNumber === 'string') {
        iouDetails.customerPhoneNumber = iouDetails.customerPhoneNumber.trim();
      }

      const trimmedNote = (iouDetails.note && typeof iouDetails.note === 'string') ? iouDetails.note.trim() : "";
      const customerAddress = iouDetails.customerAddress;
      const restDetails = Object.assign({}, iouDetails);
      delete restDetails.customerAddress;

      const modifiedCustomerAddress = (customerAddress.address1 || "") + ", " + (customerAddress.address2 || "") + ", " + (customerAddress.city || "") + ", " + (customerAddress.state || "") + ", " + (customerAddress.postCode || "");

      let iouDetailsWithDate = Object.assign({}, restDetails, {
        incidentDate: localTimeWithOffset, // Update detected field with selectedDate
        customerAddress: modifiedCustomerAddress,
      });

      // Include note if it's not empty
      if (trimmedNote !== "") {
        iouDetailsWithDate = Object.assign({}, iouDetailsWithDate, {
          note: trimmedNote,
        });
      } else {
        // console.log("Note is empty, removing it from state.");
        const remainingDetails = Object.assign({}, iouDetailsWithDate);
        delete remainingDetails.note;
        iouDetailsWithDate = remainingDetails;
      }

      // Create incident and handle potential errors
      try {
    const result = await createIncidentAPI(iouDetailsWithDate);
   if (result.success) {
      eventID = result.eventID;
      // console.log("Event created successfully with ID:", eventID);
      isEventCreated = true;
    } else {
      // Handle API failure
      setLoading(false);
      setSuccessIOU(false);
      setCurrentPage(1);

      // Show error notification based on API response
      NotificationManager.error(
        <div className="showNormalFont">
          {result.isDuplicate
            ? "⚠️ Duplicate Incident Detected: An incident with the same offense type, pump, and site has already been recorded within the last 10 minutes. A new incident cannot be created."
            : `IOU creation failed: ${result.message}`}
        </div>,
        <div className="showNormalFont">Error</div>
      );

      // Optionally, keep modal open here by NOT calling closeModal()
      return; // Stop execution, no file upload
    }
      } catch (createError) {
        console.error("Error creating incident:");
        console.error("Message:", createError.message);
        console.error("Stack:", createError.stack);
        console.error("Full error object:", createError);

        // Don't throw - handle the error gracefully
        // Reset states and show error to user
        setLoading(false);
        closeModal();
        setSuccessIOU(false);
        setCurrentPage(1);

        NotificationManager.error(
          <div className="showNormalFont">{"IOU creation failed: An unexpected error occurred. Please try again."}</div>,
          <div className="showNormalFont">Error</div>
        );
        return; // Exit early - don't continue with file upload
      }

      let fileType = "";
      if (
        selectedOption === "ID Provided" ||
        selectedOption === "No ID available (photo of customer will be taken)"
      ) {
        fileType = selectedOption === "ID Provided" ? "id" : "customer";
        isOptionSelected = true;
      }

      // Handle file upload if needed
      if (
        (eventID || (isOptionSelected && selectedOptions.eventID)) &&
        selectedFile
      ) {
        const idToUse = eventID || selectedOptions.eventID;
        try {
          await uploadFile(idToUse, selectedFile, fileType);
          // console.log("File uploaded successfully for event ID:", idToUse);
          isEventFileUploaded = true;
        } catch (uploadError) {
          // console.error("Error uploading file:");
          // console.error("Message:", uploadError.message);
          // console.error("Stack:", uploadError.stack);
          // console.error("Full error object:", uploadError);
          // console.error("Event ID used:", idToUse);
          // console.error("File type:", fileType);

          // Don't throw - handle the error gracefully
          // Reset states and show error to user
          setLoading(false);
          closeModal();
          setSuccessIOU(false);
          setCurrentPage(1);

          NotificationManager.error(
            <div className="showNormalFont">{`IOU incident was created, but the ${fileType === "id" ? "ID" : "customer"} photo could not be uploaded.`}</div>,
            <div className="showNormalFont">Error</div>
          );
          return; // Exit early
        }
      }

      // Check success conditions
      if (
        (isOptionSelected && isEventCreated && isEventFileUploaded) ||
        (!isOptionSelected && isEventCreated)
      ) {
        // console.log("Incident submission completed successfully");
        // console.log("Event ID:", eventID);
        // console.log("Option selected:", isOptionSelected);
        // console.log("File uploaded:", isEventFileUploaded);

        closeModal();
        setSuccessIOU(true);
        settitleData("Incident submitted!");
        setBodyData("The incident has been successfully submitted.");
        setLoading(false);
      }
    } catch (error) {
      // This catch block should now only handle unexpected errors
      // since we're handling API errors in their specific try-catch blocks
      console.error("Unexpected error creating IOU incident:", error);
      // console.error("=== UNEXPECTED INCIDENT SUBMISSION ERROR ===");
      // console.error("Error message:", error.message);
      // console.error("Error stack:", error.stack);
      // console.error("Full error object:", error);

      // Log additional context
      // console.error("=== ERROR CONTEXT ===");
      // console.error("Event ID:", eventID);
      // console.error("Is event created:", isEventCreated);
      // console.error("Is option selected:", isOptionSelected);
      // console.error("Is file uploaded:", isEventFileUploaded);
      // console.error("Selected option:", selectedOption);
      // console.error("Has selected file:", !!selectedFile);

      // Log the current state of key variables
      // console.error("=== STATE CONTEXT ===");
      // console.error("IOU Details:", iouDetails);
      // console.error("Selected date:", selectedDate);

      // Reset states
      setLoading(false);
      closeModal();
      setSuccessIOU(false);
      setCurrentPage(1);

      NotificationManager.error(
        <div className="showNormalFont">{"IOU creation failed: An unexpected error occurred. Please try again."}</div>,
        <div className="showNormalFont">Error</div>
      );
    }
  };

  const closeModal = () => {
    setCurrentPage(1);
    setSelectedFile(null);
    setRequiredError(false);
    setLabelError("");
    onHide();
    setIsSubmitted(false);
    setSelectedDate(new Date());
    setIouDetails((prevDetails) => {
      return Object.assign({}, intitialIouDetails, {
        pumpNumber: prevDetails.pumpNumber, // Leave pumpNumber unchanged
      });
    });

    setSelectedOption("ID Provided");
    setIouDetails(intitialIouDetails);
    resetSelectedEventData();
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the first selected file
    const validImageTypes = ["image/jpeg", "image/png", "image/gif"]; // Allowed image types

    if (!file || !validImageTypes.includes(file.type)) {
      NotificationManager.error(
        <div className="showNormalFont">
          Please upload a valid image file (JPEG, PNG, GIF)
        </div>,
        <div className="showNormalFont">Error</div>
      );
      e.target.value = ""; // Reset the file input
      return; // Return early if the file type is invalid
    }

    // Update the selectedFile state if the file type is valid
    setSelectedFile(file);
  };

  // Inside your renderPhotoUpload function
  const renderPhotoUpload = () => {
    if (
      selectedOption === "No ID available (photo of customer will be taken)" ||
      selectedOption === "ID Provided"
    ) {
      return (
        <div>
          <label
            className={isRequiredError ? "btn btn-warning" : "btn btn-primary"}
          >
            {!selectedFile ? "Take Photo" : "Retake Photo"}
            <input
              style={{ display: "none" }}
              type="file"
              onChange={handleFileChange}
              accept="image/*"
              required
            />
            {/* Accept only image files */}
          </label>
        </div>
      );
    }
    return null;
  };
  useEffect(() => {
    if (show) {
      setSelectedDate(new Date()); // Set the selectedDate to the current date when the modal is opened
    }
  }, [show]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isRequiredError, setRequiredError] = useState(false);
  const [labelError, setLabelError] = useState("");

  const isValid = (page) => {
    switch (page) {
      case 1:
        if (selectedOption === "ID Refused") {
          return true;
        } else {
          if (!selectedFile) {
            setRequiredError(true);
            return false;
          } else {
            return true;
          }
        }
      case 2:
        if (!iouDetails.customerName || !iouDetails.customerName.trim()) {
          setLabelError("customerName");
          setRequiredError(true);
          return false;
        }

        if (!iouDetails.customerPhoneNumber || !iouDetails.customerPhoneNumber.trim()) {
          setLabelError("phoneNumber");
          setRequiredError(true);
          return false;
        }

        if (!iouDetails.customerAddress || !iouDetails.customerAddress.address1 || !iouDetails.customerAddress.address1.trim()) {
          setLabelError("address1");
          setRequiredError(true);
          return false;
        }

        if (!iouDetails.customerAddress || !iouDetails.customerAddress.address2 || !iouDetails.customerAddress.address2.trim()) {
          setLabelError("address2");
          setRequiredError(true);
          return false;
        }
        if (!iouDetails.customerAddress || !iouDetails.customerAddress.city || !iouDetails.customerAddress.city.trim()) {
          setLabelError("city");
          setRequiredError(true);
          return false;
        }

        if (!iouDetails.customerAddress || !iouDetails.customerAddress.state || !iouDetails.customerAddress.state.trim()) {
          setLabelError("state");
          setRequiredError(true);
          return false;
        }
        if (
          !iouDetails.customerAddress ||
          isNaN(iouDetails.customerAddress.postCode) ||
          iouDetails.customerAddress.postCode === null ||
          iouDetails.customerAddress.postCode === "" ||
          iouDetails.customerAddress.postCode === undefined
        ) {
          setLabelError("postCode");
          setRequiredError(true);
          return false;
        } else {
          setLabelError("");
          return true;
        }
      case 3:
        if (!iouDetails.licencePlateNumber || !iouDetails.licencePlateNumber.trim()) {
          setLabelError("licencePlateNumber");
          setRequiredError(true);
          return false;
        }
        if (!iouDetails.colour || !iouDetails.colour.trim()) {
          setLabelError("colour");
          setRequiredError(true);
          return false;
        }
        if (!iouDetails.shape || !iouDetails.shape.trim()) {
          setLabelError("shape");
          setRequiredError(true);
          return false;
        }
        if (!iouDetails.make || !iouDetails.make.trim()) {
          setLabelError("make");
          setRequiredError(true);
          return false;
        } else {
          setLabelError("");
          return true;
        }
      case 4:
        if (!iouDetails.fuelType || !iouDetails.fuelType.trim()) {
          setLabelError("fuelType");
          setRequiredError(true);
          return false;
        }
        if (!iouDetails.fuelCost || !iouDetails.fuelCost.trim()) {
          setLabelError("fuelCost");
          setRequiredError(true);
          return false;
        }
        if (!iouDetails.fuelLitres || !iouDetails.fuelLitres.trim()) {
          setLabelError("fuelLitres");
          setRequiredError(true);
          return false;
        }
        // if (!iouDetails.reference?.trim()) {
        //   setLabelError("reference");
        //   setRequiredError(true);
        //   return false;
        // }

        if (
          isNaN(iouDetails.pumpNumber) ||
          iouDetails.pumpNumber === null ||
          iouDetails.pumpNumber === "" ||
          iouDetails.pumpNumber === undefined
        ) {
          setLabelError("pumpNumber");
          setRequiredError(true);
          return false;
        } else {
          setLabelError("");
          return true;
        }
      case 5:
        if (!iouDetails.reason || !iouDetails.reason.trim()) {
          setLabelError("reason");
          setRequiredError(true);
          return false;
        }
        if (!iouDetails.note || !iouDetails.note.trim()) {
          setLabelError("note");
          setRequiredError(true);
          return false;
        }
        if (!iouDetails.employeeName || !iouDetails.employeeName.trim()) {
          setLabelError("employeeName");
          setRequiredError(true);
          return false;
        } else {
          setLabelError("");
          return true;
        }
      default:
        return true;
    }
  };
  const nextPage = () => {
    if (isValid(currentPage)) {
      setRequiredError(false);
      setCurrentPage((prevPage) => (prevPage < 6 ? prevPage + 1 : prevPage));
    }
  };

  const prevPage = () => {
    if (currentPage === 1) {
      closeModal();
    }
    setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
  };

  return (
    <Modal show={show} onHide={onHide} fullscreen>
      <SimpleBackdrop open={loading} onClose={() => setLoading(false)} />
      <NotificationContainer />
      <div className="modal-dialog modal-dialog-centered modal-fullscreen modal-dialog-scrollable">
        <div
          className="modal-content"
          style={{ backgroundColor: "#212529", color: "#ADB5BD" }}
        >
          <div className="modal-header">
            <h5
              id="iou-modal"
              style={{
                color: "#FFFFFF",
                fontWeight: "500",
                fontFamily: "Ethnocentric",
              }}
            >
              Log IOU Incident
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div
            className="modal-body showNormalFont"
            style={{ padding: "10px" }}
          >
            <div className="container-fluid" style={{ marginLeft: "-5px" }}>
              <form onSubmit={handleSubmit}>
                {currentPage === 1 && (
                  <div className="container-fluid">
                    <h5 style={{ color: "#fff" }}>Customer Details</h5>
                    <h6 style={{ color: "#FFFFFF" }}>
                      Ask customer to provide ID
                    </h6>
                    <p>
                      Valid forms of ID include drivers licence, proof of age
                      card or other photo ID.
                    </p>

                    <div>
                      <div className="row pb-4">
                        <div className="col-md-12">
                          <label htmlFor="IDProvided">
                            <input
                              type="radio"
                              value="ID Provided"
                              id="IDProvided"
                              checked={selectedOption === "ID Provided"}
                              onChange={handleOptionChange}
                              style={{ margin: "0px 0px 8px" }}
                            />
                            <span className="ps-2">ID provided</span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <label htmlFor="IDnotProvided">
                            <input
                              type="radio"
                              id="IDnotProvided"
                              value="No ID available (photo of customer will be taken)"
                              checked={
                                selectedOption ===
                                "No ID available (photo of customer will be taken)"
                              }
                              style={{ margin: "0px 0px 8px" }}
                              onChange={handleOptionChange}
                            />
                            <span className="ps-2">
                              No ID available (photo of customer will be taken)
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <label htmlFor="IDRefused">
                            <input
                              type="radio"
                              value="ID Refused"
                              id="IDRefused"
                              checked={selectedOption === "ID Refused"}
                              onChange={handleOptionChange}
                              style={{ margin: "0px 0px 8px" }}
                            />
                            <span className="ps-2">ID refused</span>
                          </label>
                        </div>
                      </div>
                      <div className="row pb-4">{renderPhotoUpload()}</div>
                    </div>
                  </div>
                )}

                {currentPage === 2 && (
                  <div className="container-fluid">
                    <h5 style={{ color: "#fff" }}>Customer Details</h5>
                    <div className="row pt-2 pb-2">
                      <div className="col-md-6 ">
                        <label
                          htmlFor="customerName"
                          className={`${labelError === "customerName" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Full Name
                        </label>
                        <br />
                        <input
                          autoComplete="off"
                          type="text"
                          name="customerName"
                          id="customerName"
                          autoFocus
                          maxLength={30}
                          value={iouDetails.customerName || ""}
                          onChange={handleChange}
                          onInput={(e) => {
                            // Remove numbers and special characters
                            e.target.value = e.target.value.replace(
                              /[^A-Za-z\s]/g,
                              ""
                            );
                          }}
                          style={{
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                            borderRadius: "5px",
                            height: "2.3rem",
                            padding: "6px 12px",
                          }}
                          className={`col-12  ${isSubmitted && iouDetails.customerName === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="customerPhoneNumber"
                          className={`${labelError === "phoneNumber" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Phone Number
                        </label>
                        <br />
                        <input
                          type="text"
                          autoComplete="off"
                          name="customerPhoneNumber"
                          id="customerPhoneNumber"
                          placeholder="0412345678"
                          value={iouDetails.customerPhoneNumber || ""}
                          maxLength={12}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                            height: "2.3rem",
                            padding: "6px 12px",
                          }}
                          onInput={(e) => {
                            // Remove non-digit characters
                            let newValue = e.target.value.replace(/\D/g, "");
                            // Limit the input to 15 digits
                            newValue = newValue.slice(0, 11);
                            // Set the new value without adding the "+" sign
                            e.target.value = newValue;
                          }}
                          className={`col-12 ${isSubmitted && iouDetails.customerPhoneNumber === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        />
                        <div className="mt-2" style={{ fontSize: "14px" }}>
                          Confirm the phone number is correct by calling it.
                        </div>
                      </div>
                    </div>
                    <div className="row pb-4">
                      <div className="col-md-12">
                        <label
                          htmlFor="customerAddress.address1"
                          className={labelError === "address1" ? "text-danger" : ""}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Address
                        </label>
                        <br />

                        {googleMapsLoaded ? (
                          <PlacesAutocomplete
                            value={iouDetails.customerAddress.address1}
                            onChange={handleChangeMaps}
                            onSelect={handleSelect}
                            searchOptions={{
                              types: ["address"],
                              componentRestrictions: { country: "AU" },
                            }}
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div>
                                <input
                                  {...getInputProps({
                                    placeholder: "1234 Main St",
                                    className: `location-search-input col-12 ${isSubmitted && !iouDetails.customerAddress.address1 ? "highlight" : ""
                                      }`,
                                    id: "customerAddress.address1",
                                    style: {
                                      backgroundColor: "#212529",
                                      color: "#ADB5BD",
                                      borderColor: "#495057",
                                      border: "1px solid #495057",
                                      height: "2.3rem",
                                      padding: "6px 12px",
                                    },
                                    required: true,
                                  })}
                                />
                                <div className="autocomplete-dropdown-container">
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion) => {
                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item";

                                    return (
                                      <div
                                        key={suggestion.placeId}
                                        {...getSuggestionItemProps(suggestion, { className })}
                                      >
                                        <span style={{ marginRight: "8px" }}>•</span>
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        ) : (
                          <>
                            <input
                              type="text"
                              placeholder="1234 Main St"
                              className={`location-search-input col-12 ${isSubmitted && !iouDetails.customerAddress.address1 ? "highlight" : ""
                                }`}
                              id="customerAddress.address1"
                              style={{
                                backgroundColor: "#212529",
                                color: "#ADB5BD",
                                borderColor: "#495057",
                                border: "1px solid #495057",
                                height: "2.3rem",
                                padding: "6px 12px",
                              }}
                              value={iouDetails.customerAddress.address1}
                              onChange={(e) => handleChangeMaps(e.target.value)}
                              required
                            />
                            <div className="autocomplete-dropdown-container" style={{ color: "#ffcc00", marginTop: "4px" }}>
                              Google Maps autocomplete not working. Please type address manually.
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="row pb-4">
                      <div className="col-md-12">
                        <label
                          htmlFor="customerAddress.address2"
                          className={`${labelError === "address2" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Address 2
                        </label>
                        <br />
                        <input
                          autoComplete="off"
                          type="text"
                          name="customerAddress.address2"
                          id="customerAddress.address2"
                          placeholder="Apartment, unit, studio, or floor"
                          style={{
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                            height: "2.3rem",
                            padding: "6px 12px",
                          }}
                          value={iouDetails.customerAddress.address2 || ""}
                          maxLength={70}
                          onChange={handleChange}
                          className={`col-12 ${isSubmitted &&
                            iouDetails.customerAddress.address2 === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        />
                      </div>
                    </div>
                    <div className="row d-flex mb-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="customerAddress.city"
                          className={`${labelError === "city" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          City
                        </label>
                        <br />
                        <input
                          autoComplete="off"
                          type="text"
                          name="customerAddress.city"
                          id="customerAddress.city"
                          placeholder="Apartment, unit, studio, or floor"
                          style={{
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                            height: "2.3rem",
                            padding: "6px 12px",
                          }}
                          value={iouDetails.customerAddress.city || ""}
                          maxLength={70}
                          onChange={handleChange}
                          className={`col-12 ${isSubmitted &&
                            iouDetails.customerAddress.city === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          htmlFor="customerAddress.state"
                          className={`${labelError === "state" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          State
                        </label>
                        <br />
                        <select
                          name="customerAddress.state"
                          id="customerAddress.state"
                          style={{
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                            height: "2.3rem",
                            padding: "6px 12px",
                          }}
                          value={iouDetails.customerAddress.state || ""}
                          onChange={handleChange}
                          className={`col-12 ${isSubmitted &&
                            iouDetails.customerAddress.state === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        >
                          <option value=""></option>
                          <option value="ACT">ACT</option>
                          <option value="NSW">NSW</option>
                          <option value="NT">NT</option>
                          <option value="QLD">QLD</option>
                          <option value="SA">SA</option>
                          <option value="TAS">TAS</option>
                          <option value="VIC">VIC</option>
                          <option value="WA">WA</option>

                          {/* Add more options as needed */}
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label
                          htmlFor="customerAddress.postCode"
                          className={`${labelError === "postCode" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Post Code
                        </label>
                        <br />
                        <input
                          autoComplete="off"
                          type="text"
                          name="customerAddress.postCode"
                          id="customerAddress.postCode"
                          style={{
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                            height: "2.3rem",
                            padding: "6px 12px",
                          }}
                          value={iouDetails.customerAddress.postCode || ""}
                          onChange={handleChange}
                          maxLength={4}
                          className={`col-12 ${isSubmitted &&
                            iouDetails.customerAddress.postCode === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        />
                      </div>
                    </div>
                  </div>
                )}
                {currentPage === 3 && (
                  <div className="container-fluid">
                    <h5 style={{ color: "#fff" }}>Vehicle Details</h5>
                    <div className="row pt-2 pb-4">
                      <div className="col-md-12">
                        <label
                          htmlFor="licencePlateNumber"
                          className={`${labelError === "licencePlateNumber"
                            ? "text-danger"
                            : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Licence Plate Number
                        </label>
                        <br />
                        <input
                          autoComplete="off"
                          id="licencePlateNumber"
                          type="text"
                          autoFocus
                          name="licencePlateNumber"
                          maxLength={10}
                          style={{
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                            height: "2.3rem",
                            padding: "6px 12px",
                          }}
                          value={iouDetails.licencePlateNumber || ""}
                          onChange={handleChange}
                          className={`col-12 ${isSubmitted && iouDetails.licencePlateNumber === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        />
                      </div>
                      <div className="col-md-12 mt-4">
                        <label
                          htmlFor="colour"
                          className={`${labelError === "colour" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Colour
                        </label>
                        <br />
                        <select
                          style={{
                            height: "2.3rem",
                            padding: "6px 12px",
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                          }}
                          name="colour"
                          id="colour"
                          value={iouDetails.colour || ""}
                          onChange={handleChange}
                          className={`col-12 ${isSubmitted && iouDetails.colour === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        >
                          <option value=""></option>
                          {colors.map((color) => (
                            <option key={color} value={color}>
                              {color}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-12 mt-4">
                        <label
                          htmlFor="shape"
                          className={`${labelError === "shape" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Shape
                        </label>
                        <br />
                        <select
                          style={{
                            height: "2.3rem",
                            padding: "6px 12px",
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                          }}
                          name="shape"
                          id="shape"
                          value={iouDetails.shape || ""}
                          onChange={handleChange}
                          className={`col-12 ${isSubmitted && iouDetails.shape === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        >
                          <option value=""></option>
                          {shapes.map((shape) => (
                            <option key={shape} value={shape}>
                              {shape}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-12 mt-4">
                        <label
                          htmlFor="make"
                          className={`${labelError === "make" ? "text-danger" : ""
                            }`}
                          style={{ margin: "0px 0px 8px" }}
                        >
                          Make
                        </label>
                        <br />
                        <select
                          style={{
                            height: "2.3rem",
                            padding: "6px 12px",
                            backgroundColor: "#212529",
                            color: "#ADB5BD",
                            borderColor: "#495057",
                            border: "1px solid #495057",
                          }}
                          name="make"
                          id="make"
                          value={iouDetails.make || ""}
                          onChange={handleChange}
                          className={`col-12 ${isSubmitted && iouDetails.make === ""
                            ? "highlight"
                            : ""
                            }`}
                          required
                        >
                          <option value=""></option>
                          {models.map((model) => (
                            <option key={model} value={model}>
                              {model}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
                {currentPage === 4 && (
                  <div className="container-fluid">
                    <h5 style={{ color: "#fff" }}>Fuel Details</h5>
                    <div className="row">
                      <div className="col-12">
                        <div className="row">
                          <div className="col">
                            {/* Content for the incident date */}
                            <div className="pt-2 pb-4">
                              <label
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                When did the incident occur
                              </label>
                              <br />
                              <div
                                style={{
                                  border: "1px solid rgb(73, 80, 87)",
                                  width: "100%",
                                  backgroundColor: "#212529",
                                }}
                              >
                                <input
                                  type="datetime-local"
                                  value={formatDateTimeLocal(selectedDate)}
                                  onChange={handleDateChange}
                                  name="paymentDate"
                                  id="paymentDate"
                                  autoFocus
                                  style={{
                                    width: "100%",
                                    height: "35px", // Set a specific height if desired
                                    backgroundColor: "#212529",
                                    color: "#ADB5BD",
                                    border: "none", // Add border styling to match the container
                                    boxSizing: "border-box", // Ensure padding and border are included in the width
                                    padding: "6px 12px",
                                  }}
                                  className="custom-date-picker"
                                  min={formatDateTimeLocal(minDateTime)}
                                  max={formatDateTimeLocal(currentDateTime)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <div className="row">
                              <div className="col">
                                {/* Content for the Fuel type */}
                                <div className="pt-2 pb-4">
                                  <label
                                    htmlFor="fuelType"
                                    className={`${labelError === "fuelType"
                                      ? "text-danger"
                                      : ""
                                      }`}
                                    style={{ margin: "0px 0px 8px" }}
                                  >
                                    Fuel Type
                                  </label>
                                  <br />
                                  <select
                                    style={{
                                      height: "2.3rem",
                                      padding: "6px 12px",
                                      backgroundColor: "#212529",
                                      color: "#ADB5BD",
                                      borderColor: "#ADB5BD",
                                      border: "1px solid #495057",
                                    }}
                                    name="fuelType"
                                    id="fuelType"
                                    value={iouDetails.fuelType || ""}
                                    onChange={handleChange}
                                    className={`col-12 ${isSubmitted && iouDetails.fuelType === ""
                                      ? "highlight"
                                      : ""
                                      }`}
                                    required
                                  >
                                    <option value=""></option>
                                    {fuelTypes.map((fuelType, index) => (
                                      <option key={index} value={fuelType}>
                                        {fuelType}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            {/* Content for the fuel cost */}
                            <div className="pb-4">
                              <label
                                htmlFor="fuelCost"
                                className={`${labelError === "fuelCost" ? "text-danger" : ""
                                  }`}
                                style={{ margin: "0px 0px 8px" }}
                              >
                                Fuel Cost
                              </label>
                              <br />
                              <input
                                autoComplete="off"
                                type="text"
                                step="any"
                                name="fuelCost"
                                id="fuelCost"
                                onBlur={handleBlur}
                                value={(iouDetails && iouDetails.fuelCost) || ""}
                                style={{
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#495057",
                                  border: "1px solid #495057",
                                  height: "2.3rem",
                                  padding: "6px 12px",
                                }}
                                onChange={(e) => {
                                  const newValue = e.target.value
                                    .replace(/[^0-9.]/g, "")
                                    .replace(/^0+(?=\d)/g, "")
                                    .replace(/\.(?=.*\.)/g, "");
                                  handleChange({
                                    target: {
                                      name: "fuelCost",
                                      value: newValue,
                                    },
                                  });
                                }}
                                className={`col-12 ${isSubmitted && iouDetails && iouDetails.fuelCost === "" ? "highlight" : ""}`}
                                required
                              />

                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            {/* Content for the Litres of Fuel */}
                            <div className="pb-4">
                              <label
                                htmlFor="fuelLitres"
                                className={`${labelError === "fuelLitres"
                                  ? "text-danger"
                                  : ""
                                  }`}
                                style={{ margin: "0px 0px 8px" }}
                              >
                                Litres of Fuel
                              </label>
                              <br />
                              <input
                                autoComplete="off"
                                type="text"
                                step="any"
                                name="fuelLitres"
                                id="fuelLitres"
                                onBlur={handleBlur}
                                value={(iouDetails && iouDetails.fuelLitres) || ""}
                                onChange={(e) => {
                                  const newValue = e.target.value
                                    .replace(/[^0-9.]/g, "") // Remove non-digits and non-dots
                                    .replace(/^0+(?=\d)/g, "") // Remove leading zeros
                                    .replace(/\.(?=.*\.)/g, ""); // Remove all but the first dot

                                  handleChange({
                                    target: {
                                      name: "fuelLitres",
                                      value: newValue,
                                    },
                                  });
                                }}
                                style={{
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#495057",
                                  border: "1px solid #495057",
                                  height: "2.3rem",
                                  padding: "6px 12px",
                                }}
                                className={`col-12 ${isSubmitted && iouDetails && iouDetails.fuelLitres === "" ? "highlight" : ""}`}
                                required
                              />

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="col pb-4">
                          {/* Content for the Reference */}
                          <div>
                            <label
                              htmlFor="reference"
                              className={`${labelError === "reference" ? "text-danger" : ""
                                }`}
                              style={{ margin: "0px 0px 8px" }}
                            >
                              Reference
                            </label>
                            <br />
                            <input
                              autoComplete="off"
                              type="text"
                              name="reference"
                              id="reference"
                              maxLength={15}
                              value={iouDetails.reference || ""}
                              style={{
                                backgroundColor: "#212529",
                                color: "#ADB5BD",
                                borderColor: "#495057",
                                border: "1px solid #495057",
                                height: "2.3rem",
                                padding: "6px 12px",
                              }}
                              onChange={handleChange}
                              className={`col-12 ${isSubmitted && iouDetails.reference === ""
                                ? "highlight"
                                : ""
                                }`}
                            />
                          </div>
                          <span style={{ fontSize: "14px", color: "#ADB5BD" }}>
                            Receipt number or reference from POS
                          </span>
                        </div>
                        <div className="row">
                          <div className="col">
                            {/* Content for the Pump Number */}
                            <div className="pb-4">
                              <label
                                htmlFor="pumpNumber"
                                className={`${labelError === "pumpNumber"
                                  ? "text-danger"
                                  : ""
                                  }`}
                                style={{ margin: "0px 0px 8px" }}
                              >
                                Pump Number
                              </label>
                              <br />
                              <select
                                style={{
                                  height: "2.3rem",
                                  padding: "6px 12px",
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#495057",
                                  border: "1px solid #495057",
                                }}
                                name="pumpNumber"
                                id="pumpNumber"
                                value={iouDetails.pumpNumber || ""}
                                onChange={handleChange}
                                className={`col-12 ${isSubmitted && iouDetails.pumpNumber === ""
                                  ? "highlight"
                                  : ""
                                  }`}
                                required
                              >
                                <option value=""></option>
                                {pumpData.map((pump) => (
                                  <option key={pump.number} value={pump.number}>
                                    {pump.number}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {currentPage === 5 && (
                  <>
                    <div className="container-fluid">
                      <h5 style={{ color: "#fff" }} className="mb-4">
                        IOU Details
                      </h5>
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label
                            htmlFor="reason"
                            className={`${labelError === "reason" ? "text-danger" : ""
                              }`}
                            style={{ margin: "0px 0px 8px" }}
                          >
                            IOU Reason
                          </label>
                          <div>
                            <select
                              style={{
                                height: "2.3rem",
                                padding: "6px 12px",
                                backgroundColor: "#212529",
                                color: "#ADB5BD",
                                borderColor: "#ADB5BD",
                                border: "1px solid #495057",
                              }}
                              autoFocus
                              name="reason"
                              id="reason"
                              value={iouDetails.reason || ""}
                              onChange={handleChange}
                              className={`col-12 ${isSubmitted && iouDetails.reason === ""
                                ? "highlight"
                                : ""
                                }`}
                              required
                            >
                              <option value=""></option>
                              {reasons.map((reason, index) => (
                                <option key={index} value={reason}>
                                  {reason}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <label
                            htmlFor="note"
                            className={`${labelError === "note" ? "text-danger" : ""
                              }`}
                            style={{ margin: "0px 0px 8px" }}
                          >
                            Comments
                          </label>
                          <br />
                          <textarea
                            autoComplete="off"
                            type="text"
                            style={{
                              backgroundColor: "#212529",
                              color: "#ADB5BD",
                              borderColor: "#495057",
                              border: "1px solid #495057",
                              height: "6.3rem",
                            }}
                            name="note"
                            id="note"
                            value={iouDetails.note || ""}
                            onChange={handleChange}
                            maxLength={100}
                            className={`col-12 ${isSubmitted && iouDetails.note === ""
                              ? "highlight"
                              : ""
                              }`}
                          />
                        </div>
                        <div className="col-md-12 mt-3 mb-2">
                          <label
                            htmlFor="employeeName"
                            className={`${labelError === "employeeName" ? "text-danger" : ""
                              }`}
                            style={{ margin: "0px 0px 8px" }}
                          >
                            Employee
                          </label>
                          <br />
                          <select
                            style={{
                              height: "2.3rem",
                              padding: "6px 12px",
                              backgroundColor: "#212529",
                              color: "#ADB5BD",
                              borderColor: "#495057",
                              border: "1px solid #495057",
                            }}
                            name="employeeName"
                            id="employeeName"
                            value={iouDetails.employeeName || ""}
                            onChange={handleChange}
                            className={`col-12 ${isSubmitted && iouDetails.employeeName === ""
                              ? "highlight"
                              : ""
                              }`}
                            required
                          >
                            <option value=""></option>
                            {activeEmployees.map((employee, index) => (
                              <option key={index} value={employee.name}>
                                {employee.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="container-fluid">
                      <h5 style={{ color: "#fff" }} className="mt-4">
                        Declaration
                      </h5>
                      <div className="row pt-2 pb-4">
                        <div className="col-md-12 pb-4">
                          The <b>employee</b> agrees to the below terms:
                        </div>
                        <div className="col-md-12 mt-4">
                          By submitting this report, I declare the details to be
                          true to the best of my knowledge. I understand that a
                          person who intentionally makes a false statement in a
                          statutory declaration is guilty of an offence under
                          section 11 of the Statutory Declarations Act 1959, and
                          I believe that the statements in this declaration are
                          true in every particular.
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {currentPage === 6 && (
                  <div style={{ padding: "10px" }}>
                    <h5 style={{ color: "#fff" }}>Terms and Conditions</h5>
                    <p>
                      The <b>customer</b> agrees to the below terms:
                    </p>
                    <br />
                    <p className="update-declaration">
                      I confirm that I attended the
                      <span className="ms-1 me-1">{site ? site.toUpperCase() : ""}</span> petrol station on
                      <span className="ms-1">{formattedDate}</span> at or around
                      <span className="pe-1 ps-1">{formattedTime}</span>
                      and dispensed <span>{iouDetails.fuelLitres}</span> litres
                      of fuel into the vehicle with the registration number
                      <span className="ps-1">
                        {iouDetails.licencePlateNumber || "N/A"}
                      </span>
                      .
                      <br />
                      <br />I acknowledge that I did not pay for that fuel at
                      the time that I dispensed it and that I am therefore
                      indebted to the petrol station in the amount of
                      <span className="ps-1 pe-1">${iouDetails.fuelCost},</span>
                      being the total price of the fuel I dispensed.
                    </p>
                    <br />I agree to return to the
                    <span className="ps-1 pe-1">{site ? site.toUpperCase() : ""}</span>
                    petrol station within 4 days after the date of this
                    declaration to make full payment of my debt. I further agree
                    that if I do not pay my debt within such time that I will
                    indemnify the
                    <span className="ps-1 pe-1">{site ? site.toUpperCase() : ""}</span>
                    petrol station for all costs and expenses, including debt
                    recovery agent and legal costs, it incurs in recovering the
                    debt from me.
                  </div>
                )}
              </form>
            </div>
          </div>
          <div className="modal-footer showNormalFont">
            <div className="text-danger">
              {isRequiredError
                ? "Please answer all questions on the page before proceeding"
                : ""}
            </div>
            <button
              className="btn btn-secondary me-2 w-25 custom-btn"
              onClick={closeModal}
            >
              Close
            </button>
            <button
              className="btn btn-primary me-2 w-25 custom-btn"
              onClick={prevPage}
            >
              Back
            </button>
            {currentPage < 6 ? (
              <button
                className="btn btn-primary w-25 custom-btn"
                onClick={nextPage}
              >
                Next
              </button>
            ) : (
              <button
                className="btn btn-primary w-25 custom-btn"
                onClick={handleSubmit}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
      <DateConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        setSelectedDate={setSelectedDate}
        tempDate={tempDate} />
    </Modal>
  );
};

export default IouModal;
